import { SourceCO2eData } from 'models/MainDashboard/emissionModelSource.model';

export const OTHER_DIRECT_EMISSIONS_LABEL = 'Other Direct Emissions';

const isPurchasedCo2Label = (label: string): boolean => {
  const normalized = label.trim().toLowerCase().replace(/_/g, ' ');
  return normalized === 'purchased co2';
};

export const getEmissionSourceDisplayLabel = (
  label?: string
): string | undefined => {
  if (!label) {
    return label;
  }
  if (isPurchasedCo2Label(label)) {
    return OTHER_DIRECT_EMISSIONS_LABEL;
  }
  return label;
};

export const applyEmissionSourceDisplayLabels = (
  sources?: SourceCO2eData[]
): void => {
  sources?.forEach(item => {
    if (item.fuelName) {
      item.fuelName = getEmissionSourceDisplayLabel(item.fuelName);
    }
  });
};
